<template>
  <v-expansion-panel
    v-if="$userprofile"
    v-model="expandedIndex"
    class="elevation-0"
  >
    <v-expansion-panel-content>
      <div slot="header">
        {{ $t('emailSubscriptions') }}
      </div>
      <v-card>
        <v-card-text>
          {{ $t('emailSubscriptionsHint') }}
          <v-checkbox
            v-model="receivesMailingGeneralNews"
            color="msr"
            class="email-checkbox mt-2"
            :label="$t('emailSubscriptionsSwitchGeneral')"
            :disabled="updating"
            hide-details
          />
          <v-checkbox
            v-model="receivesMailingNewContentInGroups"
            color="msr"
            class="email-checkbox mt-1"
            :label="$t('emailSubscriptionsSwitchGroups')"
            :disabled="updating"
            hide-details
          />
          <v-checkbox
            v-model="receivesMailingNewContentCampaigns"
            color="msr"
            class="email-checkbox mt-1"
            :label="$t('emailSubscriptionsSwitchCampaigns')"
            :disabled="updating"
            hide-details
          />
          <v-checkbox
            v-model="receivesMailingNewContentBrands"
            color="msr"
            class="email-checkbox mt-1"
            :label="$t('emailSubscriptionsSwitchBrands')"
            :disabled="updating"
            hide-details
          />
          <v-checkbox
            v-model="receivesMailingNewContentDocmgr"
            color="msr"
            class="email-checkbox mt-1"
            :label="$t('emailSubscriptionSwitchMarketingManager')"
            :disabled="updating"
            hide-details
          />
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  data() {
    return {
      expandedIndex: -1,
      updating: false,
    };
  },
  computed: {
    receivesMailingGeneralNews: {
      get() {
        return (
          this.$userprofile && this.$userprofile.receives_mailing_general_news
        );
      },
      set(subscribed) {
        this.updateMailSubscription('general', subscribed);
      },
    },
    receivesMailingNewContentInGroups: {
      get() {
        return (
          this.$userprofile &&
          this.$userprofile.receives_mailing_new_content_in_groups
        );
      },
      set(subscribed) {
        this.updateMailSubscription('groups', subscribed);
      },
    },
    receivesMailingNewContentCampaigns: {
      get() {
        return (
          this.$userprofile &&
          this.$userprofile.receives_mailing_new_content_campaigns
        );
      },
      set(subscribed) {
        this.updateMailSubscription('campaigns', subscribed);
      },
    },
    receivesMailingNewContentBrands: {
      get() {
        return (
          this.$userprofile &&
          this.$userprofile.receives_mailing_new_content_brands
        );
      },
      set(subscribed) {
        this.updateMailSubscription('brands', subscribed);
      },
    },
    receivesMailingNewContentDocmgr: {
      get() {
        return (
          this.$userprofile &&
          this.$userprofile.receives_mailing_new_content_docmgr
        );
      },
      set(subscribed) {
        this.updateMailSubscription('docmgr', subscribed);
      },
    },
  },
  methods: {
    updateMailSubscription(mailingType, subscribed) {
      this.updating = true;
      return this.$api
        .updateMailSubscription(mailingType, subscribed)
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'emailSubscriptionsUpdatedSuccess',
            translate: true,
            timeout: 1000,
          });
        })
        .finally(() => {
          this.updating = false;
        });
    },
  },
};
</script>

<style scoped>
.email-checkbox >>> label.v-label {
  color: rgba(0, 0, 0, 0.77);
}
</style>



// WEBPACK FOOTER //
// src/components/EmailSubscriptions.vue